import { render, staticRenderFns } from "./CollabLiveSettings.vue?vue&type=template&id=1f286c6a&scoped=true&"
import script from "./CollabLiveSettings.vue?vue&type=script&lang=ts&"
export * from "./CollabLiveSettings.vue?vue&type=script&lang=ts&"
import style0 from "./CollabLiveSettings.vue?vue&type=style&index=0&id=1f286c6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f286c6a",
  null
  
)

export default component.exports